import React from "react";

import { RevealList } from "../motion/Reveal";

// The three list treatments the design uses. They differ on purpose: the
// hierarchy between "what we do", "how we do it" and "what sets us apart" is
// carried by the list style, not just by the heading above it.

// ── Indexed list ───────────────────────────────────────────────────────────
// Numbered rows separated by hairlines. Used for "What we do" and for the
// contact page's "Useful to include".
export function IndexedList({ items, className = "", size = "default" }) {
  const dense = size === "dense";
  return (
    <RevealList
      className={`rows flex flex-col ${className}`}
      itemClassName={`row-t flex gap-5 ${dense ? "py-3.5" : "py-4"}`}
      items={items.map((text, i) => ({ key: i, text, i }))}
      step={45}
    >
      {({ text, i }) => (
        <>
          <span className="w-6 shrink-0 font-mono text-[13px] leading-[1.7] text-fg-muted tabular-nums">
            {String(i + 1).padStart(2, "0")}
          </span>
          <span className="t-item">{text}</span>
        </>
      )}
    </RevealList>
  );
}

// ── Step list ──────────────────────────────────────────────────────────────
// Accent-numbered, brighter text, wider rows. Lives inside the raised How
// panel and carries the most weight of anything on a service page.
export function StepList({ items }) {
  return (
    <RevealList
      className="rows flex flex-col"
      itemClassName="row-t !border-line flex gap-5 py-5 sm:gap-6"
      items={items.map((text, i) => ({ key: i, text, i }))}
      step={60}
    >
      {({ text, i }) => (
        <>
          <span className="w-[26px] shrink-0 font-mono text-[13px] leading-[1.75] text-accent tabular-nums">
            {String(i + 1).padStart(2, "0")}
          </span>
          <span className="t-step">{text}</span>
        </>
      )}
    </RevealList>
  );
}

// ── Slash list ─────────────────────────────────────────────────────────────
// A slash instead of a number, because these are claims rather than a
// sequence. Larger text, more air.
export function SlashList({ items }) {
  return (
    <RevealList
      className="rows flex flex-col"
      itemClassName="row-t flex gap-5 py-6"
      items={items.map((text, i) => ({ key: i, text }))}
      step={70}
    >
      {({ text }) => (
        <>
          <span className="w-6 shrink-0 font-mono text-[15px] leading-[1.7] text-accent">/</span>
          <span className="font-body text-[16px] leading-[1.7] text-fg-body sm:text-[17px]">
            {text}
          </span>
        </>
      )}
    </RevealList>
  );
}
